// Settings Data - Constants for Chess Kingdom Settings
// Extracted from SettingsModal.jsx for better maintainability

export const BOARD_THEMES = [
  { id: 'classic', name: 'Classic', light: '#f0d9b5', dark: '#b58863' },
  { id: 'blue', name: 'Ocean Blue', light: '#dee3e6', dark: '#8ca2ad' },
  { id: 'green', name: 'Forest Green', light: '#ffffdd', dark: '#86a666' },
  { id: 'purple', name: 'Royal Purple', light: '#e8d4f2', dark: '#9b59b6' },
  { id: 'brown', name: 'Wooden', light: '#f4e4c1', dark: '#a67c52' },
  { id: 'gray', name: 'Modern Gray', light: '#e6e6e6', dark: '#888888' },
  { id: 'gold', name: 'Royal Gold', light: '#f5e6c8', dark: '#c9a227' },
  { id: 'obsidian', name: 'Obsidian', light: '#c0c0c0', dark: '#303030' },
  { id: 'pink', name: 'Cherry Blossom', light: '#ffe4ec', dark: '#d4849a' },
];

// Duke skin to board theme mappings (for auto-match feature)
export const DUKE_BOARD_THEMES = {
  // Gold tones
  gold: { light: '#f5e6c8', dark: '#c9a227' },
  goldCrown: { light: '#f5e6c8', dark: '#c9a227' },
  lightGold: { light: '#faf3e0', dark: '#d4af37' },
  darkGold: { light: '#e8dcc8', dark: '#b8860b' },
  // Silver/White tones
  silver: { light: '#e8e8e8', dark: '#a8a8a8' },
  silverOrnate: { light: '#f0f0f0', dark: '#9e9e9e' },
  platinum: { light: '#e8e8e8', dark: '#a8a8a8' },
  white: { light: '#f5f5f5', dark: '#c0c0c0' },
  whiteGoldBase: { light: '#faf8f0', dark: '#c9a227' },
  whiteOutline: { light: '#f5f5f5', dark: '#b0b0b0' },
  whiteEagle: { light: '#f0f0f0', dark: '#a0a0a0' },
  whiteMarble: { light: '#f8f8f8', dark: '#b8b8b8' },
  // Purple tones
  purple: { light: '#e8d4f5', dark: '#7b1fa2' },
  purpleVelvet: { light: '#e0d0f0', dark: '#6a1b9a' },
  // Blue tones
  blue: { light: '#d4e8f5', dark: '#1976d2' },
  blueCrown: { light: '#d0e4f8', dark: '#1565c0' },
  navyBlue: { light: '#c8d8e8', dark: '#0d47a1' },
  royalBlue: { light: '#d4e0f5', dark: '#1a237e' },
  // Green tones
  emerald: { light: '#d4f5d4', dark: '#2e7d32' },
  // Red tones
  crimson: { light: '#f5d4d4', dark: '#b71c1c' },
  ruby: { light: '#f8d0d0', dark: '#c62828' },
  // Dark tones
  dark: { light: '#d0d0d0', dark: '#424242' },
  darkSteel: { light: '#c8c8c8', dark: '#37474f' },
  blackCrown: { light: '#c0c0c0', dark: '#212121' },
  blackEagle: { light: '#c8c8c8', dark: '#263238' },
  blackMarble: { light: '#d0d0d0', dark: '#2c2c2c' },
  charcoal: { light: '#c0c0c0', dark: '#303030' },
  // B&W tones
  bwMinimalist: { light: '#f0f0f0', dark: '#404040' },
  bwDark: { light: '#e0e0e0', dark: '#303030' },
  // Epic skins
  vintageMedieval: { light: '#e8d8c0', dark: '#8b4513' },
  colossalWhite: { light: '#f0f0f0', dark: '#9e9e9e' },
  colossalBronze: { light: '#e0d0c0', dark: '#8b5a2b' },
  // Amethyst Purple
  amethystPurple: { light: '#e8d4f5', dark: '#7b2d96' },
  // Sapphire Blue
  sapphireBlue: { light: '#d4e8f8', dark: '#1565c0' },
  // Stone and Sand Kingdom
  stoneSand: { light: '#f5e6c8', dark: '#a67c52' },
  // Woodlin Warriors Kingdom
  woodlinWarriors: { light: '#d4e8d4', dark: '#2e7d32' },
  // Crown Outlined Shields
  crownBlackOutline: { light: '#e8e8e8', dark: '#2d2d2d' },
  crownWhiteOutline: { light: '#f8f8f8', dark: '#4a4a4a' },
  // Clear Crystal
  clearWhite: { light: '#f5f5ff', dark: '#a8a8c8' },
  clearBlack: { light: '#d8d8e8', dark: '#3a3a4a' },
  // Enhanced Clarity
  enhancedClarity: { light: '#f0f0f0', dark: '#808090' },
  enhancedClarityBlack: { light: '#c8c8d8', dark: '#2a2a3a' },
  // Crossed Swords
  swordsGray: { light: '#e8e8e8', dark: '#707080' },
  swordsBlack: { light: '#d0d0d8', dark: '#252530' },
  // Thick Outline
  thickOutlineWhite: { light: '#ffffff', dark: '#909090' },
  thickOutlineBlack: { light: '#b0b0b0', dark: '#1a1a1a' },
  // 3D Premium Sets
  gold3D: { light: '#fff8e8', dark: '#d4a017' },
  neonGreen3D: { light: '#e8ffe8', dark: '#00cc44' },
  purpleNeon3D: { light: '#f8e8ff', dark: '#9932cc' },
  silver3D: { light: '#f5f5f5', dark: '#808080' },
  stealthBlack3D: { light: '#d0d0d0', dark: '#1a1a1a' },
  // Flat Clear Sets
  clearWhiteFlat: { light: '#fafafa', dark: '#a0a0a0' },
  clearBlackFlat: { light: '#c0c0c0', dark: '#202020' },
  // Default
  default: { light: '#f0d9b5', dark: '#b58863' }
};

export const PIECE_THEMES = [
  { id: 'classic', name: 'Classic (White vs Dark Gray)', white: '#ffffff', black: '#2d2d2d' },
  { id: 'red_blue', name: 'Red vs Blue', white: '#e74c3c', black: '#3498db' },
  { id: 'gold_silver', name: 'Gold vs Silver', white: '#f1c40f', black: '#95a5a6' },
  { id: 'green_purple', name: 'Green vs Purple', white: '#2ecc71', black: '#9b59b6' },
  { id: 'orange_teal', name: 'Orange vs Teal', white: '#e67e22', black: '#1abc9c' },
];

// Contrasting skin combos for randomize feature
export const CONTRASTING_COMBOS = [
  // Free combos (Safe for commercial use)
  { white: 'neo', black: 'neoDark', name: 'Neo Classic' },
  { white: 'merida', black: 'meridaDark', name: 'Merida Tournament' },
  { white: 'shapes', black: 'shapesDark', name: 'Shapes Abstract' },
  { white: 'kiwenSuwi', black: 'kiwenSuwiDark', name: 'Kiwen Suwi Minimalist' },
  // Premium combos
  { white: 'golden', black: 'obsidian', name: 'Golden vs Obsidian' },
  { white: 'vintage', black: 'vintageBlack', name: 'Vintage vs Vintage Black' },
  { white: 'kawaiiWhite', black: 'kawaiiBlack', name: 'Kawaii White vs Black' },
  { white: 'kawaiiBeige', black: 'kawaii', name: 'Kawaii Beige vs Brown' },
  { white: 'fableWhite', black: 'fableBlack', name: 'Fable White vs Black' },
  { white: 'gothicWhite', black: 'gothicBlack', name: 'Gothic White vs Black' },
  { white: 'colossalWhite', black: 'colossalBronze', name: 'Colossal White vs Bronze' },
  { white: 'golden', black: 'kawaii', name: 'Golden vs Kawaii' },
  { white: 'vintage', black: 'obsidian', name: 'Vintage vs Obsidian' },
  { white: 'kawaiiWhite', black: 'vintageBlack', name: 'Kawaii White vs Vintage Black' },
  { white: 'fableWhite', black: 'obsidian', name: 'Fable White vs Obsidian' },
  { white: 'gothicWhite', black: 'fableBlack', name: 'Gothic White vs Fable Black' },
  { white: 'colossalWhite', black: 'gothicBlack', name: 'Colossal White vs Gothic Black' },
  // Cross-Faction Combos
  { white: 'amethystPurple', black: 'stoneSand', name: 'Amethyst vs Stone Kingdom' },
  { white: 'sapphireBlue', black: 'woodlinWarriors', name: 'Sapphire vs Woodlin' },
  { white: 'stoneSand', black: 'woodlinWarriors', name: 'Desert vs Forest' },
  { white: 'amethystPurple', black: 'sapphireBlue', name: 'Amethyst vs Sapphire' },
  { white: 'fableWhite', black: 'gothicBlack', name: 'Fable vs Gothic' },
  { white: 'colossalWhite', black: 'vintageBlack', name: 'Colossal vs Vintage' },
  { white: null, black: null, name: 'Classic vs Classic' },
];

// Theme Packs - Complete visual themes (pieces + Duke + board colors)
export const THEME_PACKS = [
  {
    id: 'royalGold',
    name: '👑 Royal Gold',
    description: 'Majestic golden pieces with matching Duke',
    pieceSkinWhite: 'golden',
    pieceSkinBlack: 'obsidian',
    dukeSkinWhite: 'goldCrown',
    dukeSkinBlack: 'blackCrown',
    boardTheme: 'gold'
  },
  {
    id: 'darkKnight',
    name: '🖤 Dark Knight',
    description: 'Sleek obsidian pieces with dark Duke',
    pieceSkinWhite: 'obsidian',
    pieceSkinBlack: 'obsidian',
    dukeSkinWhite: 'darkSteel',
    dukeSkinBlack: 'blackEagle',
    boardTheme: 'obsidian'
  },
  {
    id: 'vintageClassic',
    name: '📜 Vintage Classic',
    description: 'Elegant vintage pieces with classic styling',
    pieceSkinWhite: 'vintage',
    pieceSkinBlack: 'vintageBlack',
    dukeSkinWhite: 'default',
    dukeSkinBlack: 'default',
    boardTheme: 'classic'
  },
  {
    id: 'kawaiiCute',
    name: '🎀 Kawaii Cute',
    description: 'Adorable kawaii pieces for fun games',
    pieceSkinWhite: 'kawaiiWhite',
    pieceSkinBlack: 'kawaiiBlack',
    dukeSkinWhite: 'gold',
    dukeSkinBlack: 'purple',
    boardTheme: 'pink'
  },
  {
    id: 'emeraldRoyal',
    name: '💎 Emerald Royal',
    description: 'Green emerald theme with golden accents',
    pieceSkinWhite: 'golden',
    pieceSkinBlack: 'vintage',
    dukeSkinWhite: 'emerald',
    dukeSkinBlack: 'emerald',
    boardTheme: 'green'
  },
  {
    id: 'spartanWarrior',
    name: '⚔️ Spartan Warrior',
    description: 'Battle-ready pieces with warrior Duke',
    pieceSkinWhite: 'vintage',
    pieceSkinBlack: 'obsidian',
    dukeSkinWhite: 'whiteSpartan',
    dukeSkinBlack: 'darkSteel',
    boardTheme: 'obsidian'
  },
  {
    id: 'medievalFable',
    name: '🏰 Medieval Fable',
    description: 'Epic crusader warriors clash in battle',
    pieceSkinWhite: 'fableWhite',
    pieceSkinBlack: 'fableBlack',
    dukeSkinWhite: 'white',
    dukeSkinBlack: 'dark',
    boardTheme: 'brown'
  },
  {
    id: 'gothicCrusade',
    name: '⚔️ Gothic Crusade',
    description: 'Majestic gothic armies with glowing crowns',
    pieceSkinWhite: 'gothicWhite',
    pieceSkinBlack: 'gothicBlack',
    dukeSkinWhite: 'goldCrown',
    dukeSkinBlack: 'blackCrown',
    boardTheme: 'gray'
  },
  {
    id: 'colossalEpic',
    name: '🔱 Colossal Epic',
    description: 'Museum-quality sculpted pieces with flames',
    pieceSkinWhite: 'colossalWhite',
    pieceSkinBlack: 'colossalBronze',
    dukeSkinWhite: 'colossalWhite',
    dukeSkinBlack: 'colossalBronze',
    boardTheme: 'brown'
  },
  // === GEMSTONE THEME PACKS ===
  {
    id: 'amethystPurple',
    name: '💎 Amethyst Purple',
    description: 'Beautiful stained-glass purple gemstone set',
    pieceSkinWhite: 'amethystPurple',
    pieceSkinBlack: 'amethystPurple',
    dukeSkinWhite: 'amethystPurple',
    dukeSkinBlack: 'amethystPurple',
    boardTheme: 'purple'
  },
  {
    id: 'sapphireBlue',
    name: '💙 Sapphire Blue',
    description: 'Stunning stained-glass blue gemstone set',
    pieceSkinWhite: 'sapphireBlue',
    pieceSkinBlack: 'sapphireBlue',
    dukeSkinWhite: 'sapphireBlue',
    dukeSkinBlack: 'sapphireBlue',
    boardTheme: 'blue'
  },
  // === KINGDOM THEME PACKS ===
  {
    id: 'stoneSand',
    name: '🏜️ Stone & Sand Kingdom',
    description: 'Epic sand golem warriors from the desert',
    pieceSkinWhite: 'stoneSand',
    pieceSkinBlack: 'stoneSand',
    dukeSkinWhite: 'stoneSand',
    dukeSkinBlack: 'stoneSand',
    boardTheme: 'brown'
  },
  {
    id: 'woodlinWarriors',
    name: '🌲 Woodlin Warriors Kingdom',
    description: 'Ancient forest tree warriors with mystical powers',
    pieceSkinWhite: 'woodlinWarriors',
    pieceSkinBlack: 'woodlinWarriors',
    dukeSkinWhite: 'woodlinWarriors',
    dukeSkinBlack: 'woodlinWarriors',
    boardTheme: 'green'
  },
  // === CROSS-FACTION BATTLE PACKS ===
  {
    id: 'amethystVsStoneSand',
    name: '💎⚔️🏜️ Amethyst vs Stone Kingdom',
    description: 'Gemstone magic clashes with desert warriors',
    pieceSkinWhite: 'amethystPurple',
    pieceSkinBlack: 'stoneSand',
    dukeSkinWhite: 'amethystPurple',
    dukeSkinBlack: 'stoneSand',
    boardTheme: 'purple'
  },
  {
    id: 'sapphireVsWoodlin',
    name: '💙⚔️🌲 Sapphire vs Woodlin',
    description: 'Blue gemstones battle forest warriors',
    pieceSkinWhite: 'sapphireBlue',
    pieceSkinBlack: 'woodlinWarriors',
    dukeSkinWhite: 'sapphireBlue',
    dukeSkinBlack: 'woodlinWarriors',
    boardTheme: 'blue'
  },
  {
    id: 'stoneSandVsWoodlin',
    name: '🏜️⚔️🌲 Desert vs Forest',
    description: 'Sand golems clash with tree warriors',
    pieceSkinWhite: 'stoneSand',
    pieceSkinBlack: 'woodlinWarriors',
    dukeSkinWhite: 'stoneSand',
    dukeSkinBlack: 'woodlinWarriors',
    boardTheme: 'brown'
  },
  {
    id: 'amethystVsSapphire',
    name: '💎⚔️💙 Amethyst vs Sapphire',
    description: 'Purple and blue gemstones face off',
    pieceSkinWhite: 'amethystPurple',
    pieceSkinBlack: 'sapphireBlue',
    dukeSkinWhite: 'amethystPurple',
    dukeSkinBlack: 'sapphireBlue',
    boardTheme: 'purple'
  },
  {
    id: 'fableVsGothic',
    name: '🏰⚔️⚔️ Fable vs Gothic',
    description: 'Crusader warriors battle gothic knights',
    pieceSkinWhite: 'fableWhite',
    pieceSkinBlack: 'gothicBlack',
    dukeSkinWhite: 'white',
    dukeSkinBlack: 'blackCrown',
    boardTheme: 'gray'
  },
  {
    id: 'colossalVsVintage',
    name: '🔱⚔️📜 Colossal vs Vintage',
    description: 'Epic sculpted pieces vs classic elegance',
    pieceSkinWhite: 'colossalWhite',
    pieceSkinBlack: 'vintageBlack',
    dukeSkinWhite: 'colossalWhite',
    dukeSkinBlack: 'vintageMedieval',
    boardTheme: 'brown'
  },
  {
    id: 'swordsGrayVsBlack',
    name: '⚔️ Swords Gray vs Black',
    description: 'New crossed swords dukes battle',
    pieceSkinWhite: 'golden',
    pieceSkinBlack: 'obsidian',
    dukeSkinWhite: 'swordsGray',
    dukeSkinBlack: 'swordsBlack',
    boardTheme: 'gray'
  }
];
